import cementoConsejo from '../assets/images/cemento-consejo.jpg';
import ladrillosConsejo from '../assets/images/ladrillos-consejo.png';
import membranaConsejo from '../assets/images/membrana-consejo.png';
////////////////////////////////////////////////////////////////////
import ladrillosDetalle1 from '../assets/images/ladrillos-consejo-1.jpg';
import ladrillosDetalle2 from '../assets/images/ladrillos-consejo-2.jpg';
import ladrillosDetalle3 from '../assets/images/ladrillos-consejo-3.jpg';
import membranaDetalle1 from '../assets/images/membrana-consejo-1.JPG';

export const TIPS = [
    {image: ladrillosConsejo, id:"ladrillos"}, 
    {image: membranaConsejo, id:"kodertech"}, 
    {image: cementoConsejo , id:"cemento"}
];

export const FULL_ADVICES = [
    {   
        id: "ladrillos", 
        title: "¿Cuántos ladrillos necesitás?",
        listAdvices: [
            {title: "Ladrillo Común", image: ladrillosDetalle1, text: "Medidas: 5,5cm de alto, 27,5cm de largo y 12 cm de profundidas (las medidas pueden variar). En un metro cuadrado entran unos 54 ladrillos, sumando 1cm de junta."},
            {title: "Ladrillo Hueco", image: ladrillosDetalle2, text: "Medidas más utilizadas: >8cm de profundidad X 18cm de alto X 33cm de largo (para divisiones de interiores) y >12 o 18cm X 18cm X 33cm. En un metro cuadrado entran unos 17 ladrillos (con junta y sumándole un 7% de desperdicio)."},
            {title: "Bloque de Cemento", image: ladrillosDetalle3, text: "Algunos son lisos, otros texturados. Respecto a las medidas, varían las profundidades entre 10, 13, 15 y 20cm X 20cm de alto y 40cm de largo. Para un metro cuadrado se necesitan unas 12 unidades (contabilizando la junta y los residuos que se pueden generar)."},
        ]
    },
    {
        id: "kodertech",
        title: "Membrana Asfáltica", 
        listAdvices: [
            {title: "Kovertech", image: membranaDetalle1, text: "Medidas: 5,5cm de alto, 27,5cm de largo y 12 cm de profundidas (las medidas pueden variar). En un metro cuadrado entran unos 54 ladrillos, sumando 1cm de junta."},
            {title: "Ventajas", text: "Constituida por asfaltos plásticos normalizados de primera calidad. El rollo de 10m2 cubre 9m2 (solapa de 10cm aprox. en el sentido del rollo)."},
            {title: "Aplicaciones", text: "Impermeabilizaciones expuestas no transitables. Aplicable sobre losa, techos de chapa galbanizada, fibrocemento, techos con pendientes."},
        ]
    },
    {
        id: "cemento",
        title: "El Cemento y sus ventajas", 
        listAdvices: [
            {title: "¿Por qué usarlo?", image: cementoConsejo, text: "Evita la formación de micro-fisuras internas en las construcciones. Posibilita una mayor durabilidad y mejor acabado en las construcciones. ¡No olvides revisar la calidad del agregado que se va utilizar!"},
            {title: "¿Cuántas bolsas necesitás?", text: "Tené en cuenta que el consumo de cemento está afectado por muchos factores, como el tipo de ladrillo que utilizarás, por ejemplo. En mayor o menor medida se estiman 3 bolsas de 50kg de Cemento por  metro cuadrado y 1/2 metro cúbico de arena por metro cuadrado."},
        ]
    }
]

export const getAdvicebyId = (id) => FULL_ADVICES.find(a => a.id === id);
